import { render, staticRenderFns } from "./DuplicateEventsModal.vue?vue&type=template&id=253b226d&scoped=true&"
import script from "./DuplicateEventsModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateEventsModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateEventsModal.vue?vue&type=style&index=0&id=253b226d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b226d",
  null
  
)

export default component.exports